import appConfig from '../../app-config';
export const getReCaptchaSiteKey = () => {
  const { reCaptchaSiteKeyStagingSandbox, reCaptchaSiteKeyProduction } =
    appConfig || {};
  const reCaptchaSiteKey =
    process.env.GATSBY_ENV === 'production'
      ? reCaptchaSiteKeyProduction
      : reCaptchaSiteKeyStagingSandbox;
  return reCaptchaSiteKey;
};
